import { AdminPageCabecalhoComponent } from '../../shared/admin-page-cabecalho/admin-page-cabecalho.component';
import { Component, PLATFORM_ID, inject, signal } from '@angular/core';
import { GruposApiService, ListRetrieveGrupo } from '@cei-ufg/ngx-cei-seguranca';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { CeiButtonComponent, CeiPanelComponent } from '@cei-ufg/ngx-arquitetura-cei-frontend';

@Component({
  selector: 'cei-admin-grupo-detail',
  standalone: true,
  imports: [AdminPageCabecalhoComponent, CommonModule, RouterModule, CeiButtonComponent, CeiPanelComponent],
  templateUrl: './detail.component.html',
})
export class AdminGrupoDetailComponent {
  protected readonly grupo = signal<ListRetrieveGrupo | null>(null);
  private readonly gruposApi = inject(GruposApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly platformId = inject(PLATFORM_ID);

  async ngOnInit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      const data = await firstValueFrom(
        this.gruposApi.grupoRetrieve({ id }, 'body', false, {
          transferCache: false,
        })
      );
      this.grupo.set(data);
    }
  }
}
